// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__144N7","head":"ProcedureTableInfo_head__1ILiK"};